import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.66663 10L1.21635 9.78265L1.11141 10L1.21635 10.2174L1.66663 10ZM18.3333 9.99993L18.7836 10.2173L18.8885 9.99993L18.7836 9.78256L18.3333 9.99993ZM2.1169 10.2174C4.06897 6.17373 7.08064 4.25002 9.99996 4.25C12.9193 4.24998 15.9309 6.17364 17.883 10.2173L18.7836 9.78256C16.7128 5.49292 13.4025 3.24997 9.99996 3.25C6.59739 3.25003 3.28716 5.49301 1.21635 9.78265L2.1169 10.2174ZM1.21635 10.2174C3.28716 14.507 6.59739 16.75 9.99996 16.75C13.4025 16.7499 16.7128 14.5069 18.7836 10.2173L17.883 9.78256C15.9309 13.8262 12.9193 15.7499 9.99996 15.75C7.08063 15.75 4.06897 13.8263 2.1169 9.78265L1.21635 10.2174ZM12 10C12 11.1046 11.1045 12 9.99996 12V13C11.6568 13 13 11.6569 13 10H12ZM9.99996 12C8.89539 12 7.99996 11.1046 7.99996 10H6.99996C6.99996 11.6569 8.34311 13 9.99996 13V12ZM7.99996 10C7.99996 8.89543 8.89539 8 9.99996 8V7C8.34311 7 6.99996 8.34315 6.99996 10H7.99996ZM9.99996 8C11.1045 8 12 8.89543 12 10H13C13 8.34315 11.6568 7 9.99996 7V8Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }